<div class="rm-header">
  <span>Email History</span>
</div>
<mat-dialog-content>
    <p>All history is in descending order by changed time</p>
    <table width="100%" border="1">
        <thead>
            <th>Status</th>
            <th>Changed Time</th>
        </thead>
        <tbody>
            <tr *ngFor="let h of history">
                <td>{{h.emailStatus | titlecase }}</td>
                <td>{{h.statusChangedDateTime | date:'MMM d, y, h:mm:ss a'}}</td>
            </tr>
        </tbody>

    </table>
</mat-dialog-content>
<mat-dialog-actions style="display: flex; justify-content: center;">
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
